export const renderWord = (price: number) => {
  const str = String(price);
  const lastLetter = str[str.length - 1];

  if (lastLetter === "1") return "балл";

  if (lastLetter === "2" || lastLetter === "3" || lastLetter === "4")
    return "балла";

  return "баллов";
};
